import withErrorBoundary from '@Hooks/withErrorBoundary';
import Tooltip from './Tooltip';

export const { TooltipConstants } = Tooltip;
export { overridePositionTopLeft, removeClickable } from './Tooltip';
export const TooltipWithErrorBoundary = withErrorBoundary(Tooltip);
export default Tooltip;
